// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-gdansk-js": () => import("./../../../src/pages/gdansk.js" /* webpackChunkName: "component---src-pages-gdansk-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-krakow-js": () => import("./../../../src/pages/krakow.js" /* webpackChunkName: "component---src-pages-krakow-js" */),
  "component---src-pages-warszawa-js": () => import("./../../../src/pages/warszawa.js" /* webpackChunkName: "component---src-pages-warszawa-js" */),
  "component---src-pages-wroclaw-js": () => import("./../../../src/pages/wroclaw.js" /* webpackChunkName: "component---src-pages-wroclaw-js" */)
}

